import React, { Component } from 'react';


const styles = {
  ulDivStyle: {
    display: 'block',
    color: '#333',
    textAlign: 'center',
    padding: '5px 8px',
    height: '30px',
    margin: '5px',
    border: '1px solid lightgrey',
    borderRadius: '3px',
    borderTop: '2px solid lightgrey',
  },
  ulDivActiveStyle: {
    display: 'block',
    color: '#333',
    textAlign: 'center',
    padding: '5px 8px',
    height: '30px',
    margin: '5px',
    border: '1px solid lightgrey',
    borderRadius: '3px',
    borderTop: '2px solid #f76636',
  },
  ulDivHoverStyle: {
    display: 'block',
    color: '#333',
    textAlign: 'center',
    padding: '5px 8px',
    height: '30px',
    margin: '5px',
    border: '1px solid lightgrey',
    borderRadius: '3px',
    borderTop: '2px solid #f76636',
    cursor: 'pointer'
  }
}

class _EnvelopeContainer extends Component {
  constructor() {
    super()
    this.state = { hovered: false }
  }
  render() {
    const { ulDivStyle, ulDivActiveStyle, ulDivHoverStyle } = styles;
    return (
        <div
          onClick={this.props.onClick}
          onMouseEnter={() => this.setState({ hovered: true})}
          onMouseLeave={() => this.setState({ hovered: false})}
          style={this.state.hovered ? ulDivHoverStyle :
            this.props.active ? ulDivActiveStyle : ulDivStyle}>
          {this.props.children}
        </div>
    );
  }
}


export default _EnvelopeContainer;



// WEBPACK FOOTER //
// ./src/_ViewButton.js